<template>
  <div>
    <v-container fluid class="px-15">
      <!-- Spinner de carga -->
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Contenido -->
      <template v-if="!isLoading">
        <div style="position: absolute;">
          <v-btn @click="$emit('back')" text class="pl-0">
            <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
            <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
          </v-btn>
        </div>

        <!-- Titulo -->
        <v-row class="mt-6" justify="center" style="align-items: center;">
          <v-col>
            <h1 class="mb-3" style="font-family: 'montserrat-bold'; color: #193D6E; font-size: 32px; text-wrap: nowrap;">{{ "Detalle de pago" }}</h1>
          </v-col>
          <v-col cols="2">
            <v-btn block class="action-btn primary" @click="openReceipt()">
              Descargar
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-col>
          <!-- <v-col cols="2">
            <v-btn block class="action-btn primary" @click="openReceipt()">
              CEP
              <v-icon right>mdi-download</v-icon>
            </v-btn>
          </v-col> -->
        </v-row>

        <!-- Cards -->
        <v-row class="mt-2" justify="center" style="align-items: flex-end;">
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Id:</p>
                <p class="value">{{ item?.iTrackingId }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Status:</p>
                <p class="value">
                  <v-chip outlined :color="setStatusColor(item?.status.sName)" style="text-wrap: nowrap; white-space: normal;">
                    {{ item.status.sName }}
                  </v-chip>
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Profit (%):</p>
                <p class="value profit-text">{{ item.percentProfit ? formatMoney(item.percentProfit) + " %" : '-' }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Profit ($):</p>
                <p class="value profit-text">{{ item.dollarProfit ? "$" + formatMoney(item.dollarProfit) + " " + (item.profitCurrency || 'USD') : '-' }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Proveedor:</p>
                <p class="value">{{ item.payment_recipient.sName }}</p>
              </div>
              <div class="info-block">
                <p class="label">Nombre de banco:</p>
                <p class="value">{{ item.payment_recipient.sBankName }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Número de cuenta:</p>
                <p class="value">{{ item.payment_recipient.sAccountNumber ?  item.payment_recipient.sAccountNumber : item.payment_recipient.accountNumber }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Fecha de pago:</p>
                <p class="value">{{ formatDate(item.created_at) }}</p>
              </div>
              <div class="info-block">
                <p class="label">Tipo de cambio:</p>
                <p class="value">{{ item.dRate ? ("$ " + formatMoney(item.dRate) + " MXN") : (item.transaction && item.transaction[0] && item.transaction[0].transaction && item.transaction[0].transaction.dExchangeRate ? ("$ " + formatMoney(item.transaction[0].transaction.dExchangeRate) + " MXN") : "-") }}</p>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="info-block mb-0">
                <p class="label">Monto:</p>
                <template v-if="item.sCurrency != item.sDestCurrency">
                  <p class="value amount-text">{{ item.dPaymentAmount ? ("$ " + formatMoney(item.dPaymentAmount) + " " + item.sCurrency) : "-" }}</p>
                  <p class="value amount-text">{{ "$ " + formatMoney(item?.dDescAmount) + " " + item.sDestCurrency }}</p>
                </template>
                <template v-else>
                  <p class="value amount-text">{{ "$ " + formatMoney(item.dDescAmount) + " " + item.sDestCurrency }}</p>
                </template>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabla de conversiones -->
        <template>
          <!-- Texto -->
          <div style="display: flex; justify-content: space-between;" class="mt-9">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: #193D6E;">{{ "Conversiones Aplicadas" }}</div>
          </div>
          <!-- Tabla web -->
          <v-data-table hide-default-header :items="item.transaction" class="d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ texts.conversions.id }}</th>
                  <th class="header__title center">{{ texts.conversions.paymentDate }}</th>
                  <th class="header__title center">{{ texts.conversions.typeTransaction }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
                  <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
                  <th class="header__title right">{{ texts.conversions.actions }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.transaction.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.transaction.created_at) }}</td>
                  <td class="table__item">
                    <v-chip v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                      {{ "Forward" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                      {{ "Forex" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                      {{ "Withdrawal" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                      {{ "Collect" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                      {{ "Pay Now" }}
                    </v-chip>
                    <v-chip v-else-if="item.transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                      {{ "Window spot" }}
                    </v-chip>
                    <h4 v-else>
                      {{ "-" }}
                    </h4>
                  </td>
                  <td class="table__item">$ {{ formatMoney(item.transaction.dAmount > 0 ? item.dAmount / (item.transaction.dDesAmount / item.transaction.dAmount) : item.dAmount / parseFloat(item.transaction.dExchangeRate)) + " " + item.transaction.sCurrency }} </td>
                  <td class="table__item">{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " " + item.transaction.sDestCurrency : "-" }}</td>
                  <td class="table__item">{{ item.transaction.dExchangeRate ? "$ " + formatMoney(item.transaction.dExchangeRate) + " MXN" : "-" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToConversion(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ texts.conversionsHistory.viewDetail }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- Tabla mobile -->
          <v-data-table class="d-sm-none d-block" hide-default-header :items="item.transaction">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.id }}</div>
                    <div>{{ item.transaction.iTrackingId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.paymentDate }}</div>
                    <div>{{ formatDate(item.transaction.created_at) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.typeTransaction }}</div>
                    <div>
                      <v-chip v-if="item.transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                        {{ "Forward" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                        {{ "Forex" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                        {{ "Withdrawal" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                        {{ "Collect" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                        {{ "Pay Now" }}
                      </v-chip>
                      <v-chip v-else-if="item.transaction.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                        {{ "Window spot" }}
                      </v-chip>
                      <h4 v-else>
                        {{ "-" }}
                      </h4>
                    </div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountUSD }}</div>
                    <div>$ {{ formatMoney(item.transaction.dAmount > 0 ? item.dAmount / (item.transaction.dDesAmount / item.transaction.dAmount) : item.dAmount / parseFloat(item.transaction.dExchangeRate)) }} USD</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountMXN }}</div>
                    <div>{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " MXN" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.exchangeRate }}</div>
                    <div>{{ item.transaction.dExchangeRate ? "$ " + formatMoney(item.transaction.dExchangeRate) + " MXN" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.actions }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToConversion(item)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texts.conversionsHistory.viewDetail }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>

        <!-- Facturas aplicadas -->
        <div style="display: flex; justify-content: space-between; align-items: center;" class="mt-2">
          <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: #193D6E;">{{ "Facturas aplicadas" }}</div>
        </div>
         <!-- Agregar factura -->
         <template>
          <div style="text-align:start; margin: 16px 0;" class="pt-2 pb-2">
            <v-btn
              color="#0075B8"
              class="white--text"
              style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
              @click="addInvoice()"
            >
              <v-icon left>mdi-plus</v-icon>
              Agregar factura
            </v-btn>
          </div>
        </template>
        <!-- Tabla web -->
        <template v-if="item && item.invoices && item.invoices.length">
          <v-data-table hide-default-header :items="item.invoices" class="mb-4 d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title center">{{ texts.invoices.invoice }}</th>
                  <th class="header__title center">{{ texts.invoices.sId }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.purchaseDate }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.dueDate }}</th>
                  <th class="header__title center">{{ texts.invoices.rateProtection }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">Monto protegido</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
                  <th class="header__title center">{{ texts.conversions.currencyProfit }}</th>
                  <th class="header__title center">{{ texts.conversions.dollarProfit }}</th>
                  <th class="header__title right">{{ texts.conversions.actions }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="invoiceItem in items" :key="invoiceItem.id">
                  <td class="table__item">{{ invoiceItem.invoice.sInvoice }}</td>
                  <td class="table__item">{{ invoiceItem.invoice.sId }}</td>
                  <td class="table__item">{{ formatDate(invoiceItem.invoice.dPurchaseDate) }}</td>
                  <td class="table__item">{{ formatDate(invoiceItem.invoice.dDueDate) }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(invoiceItem.invoice.dRateProtection) + " MXN" }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(invoiceItem.calculatedProtectedAmount) + " " + (invoiceItem.calculatedProtectedCurrency || 'MXN') }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(invoiceItem?.invoice?.dAmount ?? invoiceItem?.invoice?.dTotalAmount ?? 0) + " " + (invoiceItem.isMX ? 'USD' : (item.sCurrency || 'USD')) }}</td>
                  <td class="table__item">{{ "$ " + formatMoney((((item.sCurrency || '').toUpperCase() === (item.sDestCurrency || '').toUpperCase()) ? (invoiceItem.totalOrignAmount || invoiceItem.totalDescAmount) : invoiceItem.totalDescAmount)) + " " + (item.sDestCurrency || 'MXN') }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ "$ " + formatMoney(invoiceItem.profit) + " " + (invoiceItem.calculatedProfitCurrency || 'USD') }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ formatMoney(invoiceItem.percentProfit) + "%" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToInvoice(invoiceItem.invoice)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ texts.conversionsHistory.viewDetail }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </template>

        <!-- Tabla mobile -->
        <template v-if="item && item.invoices && item.invoices.length">
          <v-data-table class="d-sm-none d-block" hide-default-header :items="item.invoices">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="invoiceItem in items" :key="invoiceItem.id">
                  <td class="table__item__mobile">
                    <div>{{ texts.invoices.invoice }}</div>
                    <div>{{ invoiceItem.invoice.sInvoice }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.invoices.sId }}</div>
                    <div>{{ invoiceItem.invoice.sId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.purchaseDate }}</div>
                    <div>{{ formatDate(invoiceItem.invoice.dPurchaseDate) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.dueDate }}</div>
                    <div>{{ formatDate(invoiceItem.invoice.dDueDate) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.invoices.rateProtection }}</div>
                    <div>{{ "$ " + formatMoney(invoiceItem.invoice.dRateProtection) + " MXN" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>Monto protegido</div>
                    <div>{{ "$ " + formatMoney(invoiceItem.calculatedProtectedAmount) + " " + (invoiceItem.calculatedProtectedCurrency || 'MXN') }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountUSD }}</div>
                    <div>{{ "$ " + formatMoney(invoiceItem?.invoice?.dAmount ?? invoiceItem?.invoice?.dTotalAmount ?? 0) + " " + (invoiceItem.isMX ? 'USD' : (item.sCurrency || 'USD')) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountMXN }}</div>
                    <div>{{ "$ " + formatMoney((((item.sCurrency || '').toUpperCase() === (item.sDestCurrency || '').toUpperCase()) ? (invoiceItem.totalOrignAmount || invoiceItem.totalDescAmount) : invoiceItem.totalDescAmount)) + " " + (item.sDestCurrency || 'MXN') }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.currencyProfit }}</div>
                    <div style="color: #0075B8;">{{ "$ " + formatMoney(invoiceItem.profit) + " " + (invoiceItem.calculatedProfitCurrency || 'USD') }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.dollarProfit }}</div>
                    <div style="color: #0075B8;">{{ formatMoney(invoiceItem.percentProfit) + "%" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.actions }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToInvoice(invoiceItem.invoice)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texts.conversionsHistory.viewDetail }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>
        <template v-else>
          <div style="text-align: center; padding: 40px 20px; background: #F6F8FC; border-radius: 16px; margin-top: 16px;">
            <v-icon size="64" color="#868DA6" class="mb-4">mdi-file-document-outline</v-icon>
            <div style="font-family: 'montserrat-semibold'; font-size: 18px; color: #868DA6; margin-bottom: 8px;">
              No hay facturas aplicadas
            </div>
            <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #868DA6;">
              Agrega facturas usando el botón de arriba
            </div>
          </div>
        </template>
      </template>

    </v-container>
    <!-- Dialogs -->
    <template>
      <v-dialog v-model="dialogAddInvoice" width="900px" persistent class="d-flex flex-column align-center justify-center">
        <v-overlay :value="isLoadingRelated" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card style="border-radius: 10px; min-height:126px; max-height:1400px;" class="d-flex flex-column align-center justify-center">
          <v-card-title class="justify-center pb-6 pt-10" style="font-family: 'montserrat-bold'; font-size: 26px; color: #000; width: 100%; text-align: center;">Agregar factura</v-card-title>
          <v-card-subtitle class="text-center pb-12" style="font-family: 'montserrat-regular'; font-size: 14px; color: #000;"> Seleccione la factura que desea agregar al pago</v-card-subtitle>
          <!-- Barra de progreso -->
          <div style="width: 100%; display: flex; justify-content: flex-end; margin-bottom: 16px; max-height: 100px;" class="d-flex align-center pb-4 px-8">
            <div style="min-width: 450px; background: #fff; border: 1px solid #e0e0e0; border-radius: 16px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); padding: 16px 20px 12px 20px; display: flex; flex-direction: column; align-items: flex-start;">
              <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-bottom: 4px;">
                <span style="font-family: 'montserrat-bold'; font-size: 16px;">Monto cubierto {{ isMXAccount ? '(USD)' : '(MXN)' }}</span>
                <span style="font-family: 'montserrat-bold'; font-size: 16px;">
                  ${{ formatMoney(amountCovered + selectedInvoicesLocal.filter(inv => !inv.isRelated).reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0)) }} / ${{ formatMoney(amountTotal) }} {{ isMXAccount ? 'USD' : 'MXN' }}
                </span>
              </div>
              <v-progress-linear
                :value="amountTotal > 0 ? ((amountCovered + selectedInvoicesLocal.filter(inv => !inv.isRelated).reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0)) / amountTotal) * 100 : 0"
                color="#0075B8"
                height="12"
                rounded
                background-color="#D3D3D3"
                style="width: 100%; margin-top: 2px;"
              />
            </div>
          </div>
          <!-- Select de facturas -->
          <v-card-text v-if="!isAmountFullyCovered" class="d-flex flex-column align-center justify-center px-10 py-6" style="background: #F6F8FC; border-radius: 16px; max-width: fit-content; min-width: 400px;  max-width: 450px; border: none; box-shadow: 0 2px 4px rgba(0,0,0,0.1); max-height: 25px;">
            <v-select
              v-model="selectedInvoiceIds"
              :items="filteredInvoicesAvailable"
              :item-text="item => 'PO: ' + (item.sId || '-') + ' | INV: ' + (item.sInvoice || '-') + ' - ' + formatMoney(item.dTotalAmount) + (isMXAccount ? ' USD' : ' MXN')"
              item-value="sInvoiceId"
              label="Facturas"
              dense
              class="no-border-select"
              multiple
              @change="handleSelectInvoices"
            >
            </v-select>
          </v-card-text>
          <!-- Mensaje cuando el monto está cubierto -->
          <!-- <v-card-text v-else class="d-flex flex-column align-center justify-center px-10 py-6" style="background: #F6F8FC; border-radius: 16px; max-width: fit-content; min-width: 400px;  max-width: 450px; border: none; box-shadow: 0 2px 4px rgba(0,0,0,0.1); max-height: 25px;">
            <div style="text-align: center; color: #0075B8; font-family: 'montserrat-semibold';">
              El monto total ya está cubierto
            </div>
          </v-card-text> -->
          <!-- Facturas ya asociadas -->
          <div v-if="selectedInvoicesLocal.length > 0" class="invoices-container">
            <div class="invoice-list-vertical">
              <div
                v-for="invoice in selectedInvoicesLocal"
                :key="invoice.sInvoiceId"
                class="invoice-card invoice-card-horizontal"
              >
                <div class="invoice-card-horizontal-content">
                  <div class="invoice-card-horizontal-main">
                    <div class="invoice-title">Factura {{ invoice.sInvoice }}</div>
                    <div class="invoice-card-horizontal-row">
                      <div class="invoice-data-block">
                        <div class="label">Fecha de compra:</div>
                        <div class="value">{{ formatDate(invoice.dPurchaseDate) }}</div>
                      </div>
                      <template v-if="isMXAccount">
                        <div class="invoice-data-block">
                          <div class="label">Monto total:</div>
                          <div class="value">$ {{ formatMoney(invoice.dTotalAmount || 0) }} USD</div>
                        </div>
                        <div class="invoice-data-block">
                          <div class="label">Monto en MXN:</div>
                          <div class="value">$ {{ formatMoney((invoice.dTotalAmount || 0) * (invoice.dRateProtection || 0)) }} MXN</div>
                        </div>
                        <div class="invoice-data-block">
                          <div class="label">TC Protección:</div>
                          <div class="value">$ {{ formatMoney(invoice.dRateProtection) }} MXN</div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="invoice-data-block">
                          <div class="label">Monto total USD:</div>
                          <div class="value">$ {{ formatMoney(invoice.dTotalAmountUSD || invoice.dTotalUsd || invoice.dAmount) }} USD</div>
                        </div>
                        <div class="invoice-data-block">
                          <div class="label">Monto total MXN:</div>
                          <div class="value">$ {{ formatMoney(invoice.dTotalAmountMXN || invoice.dTotalAmount) }} MXN</div>
                        </div>
                        <div class="invoice-data-block">
                          <div class="label">Protección TC:</div>
                          <div class="value">$ {{ formatMoney(invoice.dRateProtection) }} MXN</div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <v-btn icon color="red" @click="invoice.isRelated ? openRemoveInvoiceDialog(invoice) : removeLocalInvoice(invoice.sInvoiceId)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
          <!--Boton de agregar-->
          <v-card-actions class="d-flex flex-row align-center justify-center py-8" style="width: 100%; gap: 16px;">
            <v-btn
              color="#0075B8"
              elevation="8"
              class="mr-2 px-10"
              style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
              outlined
              @click="cancelAddInvoice()"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="#0075B8"
              elevation="8"
              class="white--text px-10"
              style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
              @click="addInvoiceToPayment()"
              :disabled="isAddInvoiceDisabled || isLoadingRelated"
            >
              Agregar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de creación de factura -->
      <v-dialog v-model="dialogCreateInvoice" persistent max-width="600px">
        <v-card>
          <v-card-title style="display: flex; justify-content: center">
            <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ texts.invoices.addInvoice }}</span>
          </v-card-title>
          <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
            <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ texts.invoices.addInvoiceDetailText }}</span>
          </v-card-subtitle>
          <v-card-text class="pb-1">
            <v-container>
              <v-row>
                <v-form
                  ref="formNewInvoice"
                  style="width: 100%"
                  lazy-validation
                  v-on:submit.prevent
                >
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.invoice + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        v-model="forms.new.sInvoice"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.sId"
                        required
                        style="border-radius: 10px"
                        outlined
                        v-model="forms.new.sId"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-autocomplete
                        :label="texts.invoices.supplier + '*'"
                        required
                        style="border-radius: 10px"
                        :items="suppliers"
                        outlined
                        item-text="sName"
                        return-object
                        v-model="forms.new.sSupplier"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.purchaseDate + '*'"
                        required
                        style="border-radius: 10px"
                        outlined
                        type="date"
                        v-model="forms.new.dPurchaseDate"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-text-field
                        :label="(forms?.new?.sSupplier?.sAccountCurrency === 'MXN' ? texts.invoices.totalAmountMXN : texts.invoices.totalAmountUSD) + '*'"
                        required
                        outlined
                        style="border-radius: 10px"
                        type="number"
                        v-model="forms.new.dTotalAmount"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.creditTime + '*'"
                        required
                        outlined
                        style="border-radius: 10px"
                        type="number"
                        v-model="forms.new.iCreditPeriod"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" class="pb-0">
                      <v-text-field
                        :label="texts.invoices.exchangeRateProtected + '*'"
                        required
                        outlined
                        style="border-radius: 10px"
                        type="number"
                        v-model="forms.new.dRateProtection"
                        :rules="[rules.required]"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-row>
            </v-container>
            <small>*{{ texts.invoices.requiredField }}</small>
          </v-card-text>
          <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
            <v-btn
              color="#0075B8"
              elevation="8"
              class="mr-2 px-10"
              style="border-radius: 36px; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
              outlined
              :disabled="loading"
              @click="cancelCreateInvoice()"
            >
              {{ texts.modalForm.cancel }}
            </v-btn>
            <v-btn
              color="#0075B8"
              elevation="8"
              class="white--text px-10"
              style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
              :disabled="loading"
              :loading="loading"
              @click="saveInvoice(false)"
            >
              {{ texts.modalForm.save }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de factura duplicada -->
      <v-dialog v-if="dialogDuplicate" v-model="dialogDuplicate" persistent max-width="fit-content">
        <v-card>
          <v-card-title class="text-h5 my-4">
            {{ texts.invoices.invoiceDuplicateTitle }}
          </v-card-title>
          <v-card-text v-if="!loading" class="my-6">
            {{ texts.invoices.invoiceDuplicateSubtitle }}
          </v-card-text>
          <div v-else style="display: flex; justify-content: center">
            <v-progress-circular indeterminate color="amber"></v-progress-circular>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text :disabled="loading" @click="dialogDuplicate = false"> {{ texts.modalForm.cancel }} </v-btn>
            <v-btn color="#193D6E" :disabled="loading" @click="saveInvoice(true)" style="color: white;">
              {{ texts.modalForm.save }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de confirmación de eliminación de factura -->
      <v-dialog v-model="dialogRemoveInvoice" persistent max-width="fit-content">
        <v-card>
          <v-card-title class="text-h5 my-4">
            ¿Estás seguro que deseas eliminar esta factura?
          </v-card-title>
          <v-card-text class="my-6">
            Esta acción eliminará la factura <b>{{ invoiceToRemove?.sInvoice }}</b> de este pago. ¿Deseas continuar?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialogRemoveInvoice = false"> Cancelar </v-btn>
            <v-btn color="#193D6E" style="color: white;" @click="confirmRemoveInvoice()">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <v-dialog v-model="dialogInvoiceDetail" max-width="1400px" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <InvoiceDetail
            v-if="selectedInvoiceId"
            :s-invoice-id="selectedInvoiceId"
            @back="dialogInvoiceDetail = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInvoiceMXDetail" max-width="1400px" scrollable>
      <v-card>
        <v-card-text class="pa-0">
          <InvoiceMXDetail
            v-if="selectedInvoiceMXId"
            :s-invoice-mx-id="selectedInvoiceMXId"
            @back="dialogInvoiceMXDetail = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { mixs } from "@/mixins";
import InvoiceDetail from "../Operations/InvoiceDetail.vue";
import InvoiceMXDetail from "../Operations/InvoiceMXDetail.vue";

export default {
  name: "PaymentDetail",
  mixins: [mixs],
  components: {
    InvoiceDetail,
    InvoiceMXDetail,
  },
  props: {
    sPaymentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      nameXLSX: "HistorialPagos.xlsx",
      texts: "",
      loading: true,
      isLoading: false,
      headersInvoices: [
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        // this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      dTotalAmount: "",
      dDescAmount: "",
      item: null,
      invoices: [],
      accountType: null,
      dialogAddInvoice: false,
      dialogCreateInvoice: false,
      dialogDuplicate: false,
      invoicesAvailable: [],
      selectedInvoice: null,
      suppliers: [],
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
      },
      forms: {
        new: {
          dPurchaseDate: "",
          sPaymentRecipientId: "",
          sInvoice: "",
          sId: "",
          dTotalAmount: "",
          dRateProtection: "",
          iCreditPeriod: "",
        },
      },
      relatedInvoices: [],
      amountCovered: 0,
      amountTotal: 0,
      isLoadingRelated: false,
      selectedInvoicesLocal: [],
      selectedInvoiceIds: [], // <--- NUEVO
      dialogRemoveInvoice: false,
      invoiceToRemove: null,
      dialogInvoiceDetail: false,
      selectedInvoiceId: null,
      dialogInvoiceMXDetail: false,
      selectedInvoiceMXId: null,
    };
  },
  created() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getPaymentsHistory();
    this.getSuppliers();
  },
  methods: {
    openReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: this.item.sPaymentId
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/openReceipt`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.item.payment_recipient.sName + (this.item.invoice ? "_" + this.item.invoice : "")}.pdf`;
        link.click();
      })
      .catch((error) => {
        this.mixError(
          error?.response?.data?.message || "No se pudo descargar el archivo",
          error?.response?.status || 500
        );
      })
      .finally(() => {
        this.loading = false;
      });
    },
    goToConversion(item) {
      this.$router.push("/conversions/" + item.sTransactionId);
    },
    goToInvoice(item) {
      if (!item) return;
      if (item.sInvoiceMXId) {
        this.selectedInvoiceMXId = item.sInvoiceMXId;
        this.dialogInvoiceMXDetail = true;
      } else {
        this.selectedInvoiceId = item.sInvoiceId;
        this.dialogInvoiceDetail = true;
      }
    },
    getPaymentsHistory() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payments/${this.sPaymentId}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          this.item = response.data.payment;
          this.accountType = this.item.sAccountType || 'EFEXUSD';

          this.item.invoice = this.item.invoice_payments_relationship
          this.item.dExchangeRateReal = this.item.transaction[0].transaction.dAmount > 0
            ? this.item.transaction[0].transaction.dDesAmount / this.item.transaction[0].transaction.dAmount
            : parseFloat(this.item.transaction[0].transaction.dExchangeRate);
          if (this.item.totalActualCost) {
            this.item.dAmount = parseFloat(this.item.totalActualCost)
          } else {
            this.item.dAmount = this.item.dDescAmount / this.item.dExchangeRateReal;
          }
          this.item.dTotalAmount = 0;
          if (this.item.invoice_payments_relationship) {
            this.item.invoice_payments_relationship.map((invoice) => {
              this.item.dTotalAmount += parseFloat(invoice.dAmount);
                return invoice;
            })
          }
          this.dTotalAmount = this.item.dTotalAmount;
          this.dDescAmount = this.item.dDescAmount;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Fecha de pago": item.created_at ? this.formatDate(item.created_at) : "",
            "Destinatario": item.payment_recipient.sName ? item.payment_recipient.sName : "N/A",
            Invoice: item.invoice ? item.invoice : "",
            "Type Transaction": item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' ? 'Forward' : (item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' ? 'Forex' : (item.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73' ? 'Pay Now' : "N/A")),
            "Total amount (MXN)": item.dDesAmount ? parseFloat(item.dDesAmount) : "",
            "Total amount (USD)": item.dAmount ? parseFloat(item.dAmount) : "",
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate : "",
            "Currency profit (%)": item.percentProfit ? parseFloat(item.percentProfit) : "",
            "Currency gain (USD)": item.dollarProfit ? parseFloat(item.dollarProfit) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    setStatusColor: function (status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
       else {
        return "gray";
      }
    },
    async createInvoice() {
      this.dialogAddInvoice = false;
      this.dialogCreateInvoice = true;
      if (!this.suppliers || this.suppliers.length === 0) {
        await this.getSuppliers();
      }
    },
    cancelCreateInvoice() {
      this.dialogCreateInvoice = false;
      this.resetForm();
    },
    resetForm() {
      this.forms.new = {
        dPurchaseDate: "",
        sPaymentRecipientId: "",
        sInvoice: "",
        sId: "",
        dTotalAmount: "",
        dRateProtection: "",
        iCreditPeriod: "",
      };
      if (this.$refs.formNewInvoice) {
        this.$refs.formNewInvoice.resetValidation();
      }
    },
    async getSuppliers() {
      try {
        const response = await DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });
        this.suppliers = response.data.paymentRecipients;
      } catch (error) {
        console.log('Error loading suppliers:', error);
        this.mixError(error.response?.data?.message || "Error al cargar proveedores", error.response?.status || 500);
      }
    },
    saveInvoice(isValid = false) {
      if (this.$refs.formNewInvoice.validate()) {
        this.loading = true;

        let payload = {
          dPurchaseDate: this.forms.new.dPurchaseDate,
          sPaymentRecipientId: this.forms.new.sSupplier.sPaymentRecipientId,
          sInvoice: this.forms.new.sInvoice,
          sId: this.forms.new.sId,
          dTotalAmount: this.forms.new.dTotalAmount,
          dRateProtection: this.forms.new.dRateProtection,
          iCreditPeriod: this.forms.new.iCreditPeriod,
          skipDuplicate: isValid,
          contactData: {
            create: false,
          },
        };

        DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          if(response.status === 202){
            this.dialogDuplicate = true;
            this.loading = false;
          }
          else {
            this.loading = false;
            this.dialogDuplicate = false;
            this.dialogCreateInvoice = false;
            this.resetForm();
            this.mixSuccess("Factura creada exitosamente", 200);
            this.getInvoicesAvailable();
            this.dialogAddInvoice = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response?.data?.message || "Error al crear la factura", error.response?.status || 500);
        });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    async addInvoice() {
     this.dialogAddInvoice = true;
     this.isLoadingRelated = true;
     if (this.isMXAccount) {
       await this.getInvoicesAvailableMX();
       await this.fetchRelatedInvoicesMX();
     } else {
       await this.getInvoicesAvailable();
       if (!this.suppliers || this.suppliers.length === 0) {
         await this.getSuppliers();
       }
       await this.fetchRelatedInvoices();
     }
     this.selectedInvoiceIds = this.selectedInvoicesLocal.map(inv => inv.sInvoiceId);
     this.selectedInvoicesLocal = this.selectedInvoicesLocal.filter(inv => inv.isRelated);
     this.isLoadingRelated = false;
    },
    getInvoicesAvailable() {
      this.operationType = this.$store.state.OperationType;
      if (this.operationType === "Compra") {
        this.baseCurrency = 'MXN';
        this.targetCurrency = 'USD';
      } else {
        this.baseCurrency = 'USD';
        this.targetCurrency = 'MXN';
      }

      const payload = {
        currency: this.baseCurrency,
        des_currency: this.targetCurrency,
        sExchangeRate: this.item.dRate,
        sPaymentRecipientId: this.item.sPaymentRecipientId
      };

      return DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/available`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.invoicesAvailable = response.data.invoices || [];
      })
      .catch((error) => {
        console.log(error);
        this.invoicesAvailable = [];
      });
    },
    async getInvoicesAvailableMX() {
      try {
        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/invoicesMx/available`, {}, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ''
          }
        });
        this.invoicesAvailable = (response.data.invoices || []).map(inv => ({
          ...inv,
          sInvoiceId: inv.sInvoiceId || inv.sInvoiceMXId
        }));
      } catch (error) {
        console.error('[getInvoicesAvailableMX] Error:', error);
        this.invoicesAvailable = [];
      }
    },
    async addInvoiceToPayment() {
      if (!this.selectedInvoicesLocal.length) return;
      this.isLoadingRelated = true;
      const uniqueInvoices = [];
      const seen = new Set();
      for (const invoice of this.selectedInvoicesLocal) {
        if (!invoice.isRelated && !seen.has(invoice.sInvoiceId)) {
          uniqueInvoices.push(invoice);
          seen.add(invoice.sInvoiceId);
        }
      }

      if (uniqueInvoices.length === 0) {
        this.isLoadingRelated = false;
        this.dialogAddInvoice = false;
        return;
      }

      try {
        let endpoint, payload;
        if (this.isMXAccount) {
          endpoint = `${URI}/api/v1/${this.selectLanguage}/payments/addInvoiceMX`;
          payload = {
            sPaymentId: this.item.sPaymentId,
            sInvoiceMXIds: uniqueInvoices.map(inv => inv.sInvoiceId)
          };
        } else {
          endpoint = `${URI}/api/v1/${this.selectLanguage}/payments/addInvoice`;
          payload = {
            sPaymentId: this.item.sPaymentId,
            sInvoiceIds: uniqueInvoices.map(inv => inv.sInvoiceId)
          };
        }

        const response = await DB.post(endpoint, payload, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });

        if (response.data && response.data.success) {
          this.mixSuccess(response.data.message, 200);
        } else {
          this.mixError(response.data.message, 400);
        }
        this.dialogAddInvoice = false;
        this.selectedInvoicesLocal = [];
        this.selectedInvoiceIds = [];
        this.getPaymentsHistory();
      } catch (e) {
        this.mixError(e?.response?.data?.message || 'No se pudo agregar la factura', e?.response?.status || 500);
      } finally {
        this.isLoadingRelated = false;
      }
    },
    cancelAddInvoice() {
      this.dialogAddInvoice = false;
      this.selectedInvoicesLocal = [];
      this.selectedInvoiceIds = [];
    },
    removeInvoice(sInvoiceId) {
      this.selectedInvoice = this.selectedInvoice.filter(id => id !== sInvoiceId);
    },
    async fetchRelatedInvoices() {
      try {
        const response = await DB.get(`${URI}/api/v1/${this.selectLanguage}/payments/${this.item.sPaymentId}/related-invoices`, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });
        this.selectedInvoicesLocal = (response.data.invoices || []).map(inv => ({
          ...inv,
          sInvoiceId: inv.sInvoiceId,
          isRelated: true
        }));
        this.amountCovered = response.data.amountCovered || 0;
        this.amountTotal = response.data.amountTotal || 0;
      } catch (e) {
        this.selectedInvoicesLocal = [];
        this.amountCovered = 0;
        this.amountTotal = 0;
      }
    },
    async fetchRelatedInvoicesMX() {
      try {
        const response = await DB.get(`${URI}/api/v1/${this.selectLanguage}/payments/${this.item.sPaymentId}/related-invoices-mx`, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });
        this.selectedInvoicesLocal = (response.data.invoices || []).map(inv => ({
          ...inv,
          sInvoiceId: inv.sInvoiceId || inv.sInvoiceMXId,
          isRelated: true
        }));
        this.amountCovered = response.data.amountCovered || 0;
        this.amountTotal = response.data.amountTotal || 0;
      } catch (e) {
        this.selectedInvoicesLocal = [];
        this.amountCovered = 0;
        this.amountTotal = 0;
      }
    },
    handleSelectInvoices(val) {
      let totalCovered = this.amountCovered + this.selectedInvoicesLocal
        .filter(inv => !inv.isRelated)
        .reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0);

      const newSelected = this.invoicesAvailable
        .filter(inv => val.includes(inv.sInvoiceId) && !this.selectedInvoicesLocal.some(sel => sel.sInvoiceId === inv.sInvoiceId));

      for (const invoice of newSelected) {
        const invoiceAmount = parseFloat(invoice.dTotalAmount || 0);
        if ((totalCovered + invoiceAmount) > this.amountTotal) {
          this.mixError('El monto de la factura excede el saldo restante a cubrir.', 400);
          this.selectedInvoiceIds = this.selectedInvoiceIds.filter(id => id !== invoice.sInvoiceId);
          continue;
        }
        totalCovered += invoiceAmount;
        this.selectedInvoicesLocal.push({ ...invoice, isRelated: false });
      }
    },
    removeLocalInvoice(sInvoiceId) {
      this.selectedInvoicesLocal = this.selectedInvoicesLocal.filter(inv => inv.sInvoiceId !== sInvoiceId);
      this.selectedInvoiceIds = this.selectedInvoiceIds.filter(id => id !== sInvoiceId);
    },
    async removeRelatedInvoice(sInvoiceId) {
      this.isLoadingRelated = true;
      try {
        let endpoint;
        if (this.isMXAccount) {
          endpoint = `${URI}/api/v1/${this.selectLanguage}/payments/${this.item.sPaymentId}/invoices-mx/${sInvoiceId}`;
        } else {
          endpoint = `${URI}/api/v1/${this.selectLanguage}/payments/${this.item.sPaymentId}/invoices/${sInvoiceId}`;
        }
        await DB.delete(endpoint, {
          headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : '' }
        });
        if (this.isMXAccount) {
          await this.fetchRelatedInvoicesMX();
          await this.getInvoicesAvailableMX();
        } else {
          await this.fetchRelatedInvoices();
          await this.getInvoicesAvailable();
        }
        this.selectedInvoicesLocal = this.selectedInvoicesLocal.filter(inv => inv.isRelated);
        this.selectedInvoiceIds = this.selectedInvoicesLocal.map(inv => inv.sInvoiceId);
        this.mixSuccess('Factura eliminada correctamente', 200);
      } catch (e) {
        this.mixError(e?.response?.data?.message || 'No se pudo desasociar la factura', e?.response?.status || 500);
      } finally {
        this.isLoadingRelated = false;
      }
    },
    openRemoveInvoiceDialog(invoice) {
      this.invoiceToRemove = invoice;
      this.dialogRemoveInvoice = true;
    },
    confirmRemoveInvoice() {
      if (this.invoiceToRemove) {
        if (this.invoiceToRemove.isRelated) {
          this.removeRelatedInvoice(this.invoiceToRemove.sInvoiceId);
        } else {
          this.removeLocalInvoice(this.invoiceToRemove.sInvoiceId);
        }
      }
      this.dialogRemoveInvoice = false;
      this.invoiceToRemove = null;
    }
  },
  beforeCreated() {
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    isMXAccount() {
      return this.accountType === 'EFEXMXN';
    },
    selectedInvoiceObj() {
      return this.invoicesAvailable.find(inv => inv.sInvoiceId === this.selectedInvoice) || null;
    },
    selectedInvoices() {
      if (!this.selectedInvoice || !Array.isArray(this.selectedInvoice)) {
        return [];
      }
      return this.invoicesAvailable.filter(inv => this.selectedInvoice.includes(inv.sInvoiceId));
    },
    isAddInvoiceDisabled() {
      return !this.selectedInvoicesLocal.length;
    },
    isAmountFullyCovered() {
      return (
        this.amountTotal > 0 &&
        (this.amountCovered +
          this.selectedInvoicesLocal
            .filter(inv => !inv.isRelated)
            .reduce((sum, inv) => sum + parseFloat(inv.dTotalAmount || 0), 0)
        ) >= this.amountTotal
      );
    },
    filteredInvoicesAvailable() {
      const selectedIds = this.selectedInvoicesLocal.map(inv => inv.sInvoiceId);
      return this.invoicesAvailable.filter(inv => !selectedIds.includes(inv.sInvoiceId));
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    }
  }
};
</script>

<style scoped>
.text-return {
  font-family: "montserrat-medium";
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F6F8FC;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
}

.profit-text {
  color: #0075B8;
}

.amount-text {
  font-size: 22px;
  color: black;
  font-family: "montserrat-bold";
}

.action-btn {
  border-radius: 36px;
  font-family: "montserrat-semibold";
  text-transform: none;
  border: 2px solid #0075BB;
}

.action-btn.primary {
  background-color: #0075B8;
  color: white;
}

.v-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-border-select >>> .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

.no-border-select >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
}

.no-border-select >>> .v-input__slot::before {
  border: none !important;
}

.no-border-select >>> .v-input__slot::after {
  border: none !important;
}

.no-border-select >>> .v-text-field__slot {
  border: none !important;
}

.no-border-select >>> .v-text-field__slot::before {
  border: none !important;
}

.no-border-select >>> .v-text-field__slot::after {
  border: none !important;
}

.custom-multiple-select >>> .v-input__slot {
  min-height: 36px !important;
  padding: 4px 8px !important;
  justify-content: space-between !important;
}

.custom-multiple-select >>> .v-select__selections {
  display: none !important;
}

.custom-multiple-select >>> .v-input__append-outer {
  margin-left: 0 !important;
}

.invoice-list-vertical {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.invoice-card {
  background: #F2F2F2;
  border-radius: 24px;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0 auto;
  width: 100%;
  max-width: 850px;
  overflow: auto;
  padding: 20px 28px 18px 28px;
  transition: all 0.3s;
}

.invoice-card-horizontal-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.invoice-card-horizontal-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.invoice-title {
  font-size: 2rem;
  font-family: 'montserrat-bold';
  color: #222;
  margin-bottom: 12px;
}

.invoice-card-horizontal-row {
  display: flex;
  flex-direction: row;
  gap: 32px;
}

.invoice-data-block {
  min-width: 140px;
  max-width: 180px;
}

.delete-icon {
  font-size: 2rem !important;
  cursor: pointer;
  align-self: flex-start;
  margin-left: 32px;
}

.invoices-container {
  width: 100%;
  margin-bottom: 16px;
  margin-top: 16px;
  max-height: 600px;
  overflow-y: auto;
  padding: 0 32px;
}

.invoices-container::-webkit-scrollbar {
  width: 8px;
}

.invoices-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.invoices-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.invoices-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
